import type { IBounds } from './Bounds.interface';

export enum IBackgroundType {
  image = 'background-image',
  color = 'background-color',
}

export type IBackgroundImage = {
  type: IBackgroundType.image;
  image: Blob;
  bounds: Omit<IBounds, 'zIndex'>;
};
export type IBackgroundColor = {
  type: IBackgroundType.color;
  color: string;
};

export type IThemeBackground = IBackgroundImage | IBackgroundColor;

export interface IStudioTheme {
  background?: IThemeBackground;
}
